import React from 'react';
import { BaasicInput, Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const DaVinciBusinessPartnersTemplate = ({
	t,
	viewStore,
	viewStore: { loading, form, data, listStore, tableData, onSearchChange, onBusinessPartnerSelect },
}) => {
	if (loading) return <Loader />;
	return (
		<section className="flex--grow--1">
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('DAVINCIBUSINESSPARTNERS.TITLE')}</h3>
			</div>
			<div className="ReactModal__body">
				<div className="col col-sml-12 col-lrg-6">
					<BaasicInput field={form.$('description')} onKeyUp={onSearchChange} autoFocus={true} />
				</div>
				{data && (
					<div className="flex--grow--1">
						<BaasicTable
							{...{
								listStore,
								data,
								tableData,
								viewStore,
								noDataItem: true,
							}}
							rowRender={(trElement, props) => CustomRowRender(trElement, props, onBusinessPartnerSelect)}
						/>
					</div>
				)}
			</div>
			<div className="ReactModal__footer"></div>
		</section>
	);
};

function CustomRowRender(trElement, props, onBusinessPartnerSelect) {
	return (
		<tr
			onClick={() => onBusinessPartnerSelect(props.dataItem.id)}
			className={'not-expandable ' + trElement.props.className + ' is-clickable'}
		>
			{trElement.props.children}
		</tr>
	);
}

export default defaultTemplate(DaVinciBusinessPartnersTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/seller/pages/DaVinciBusinessPartnersTemplate.jsx